var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "45EA3986-8217-48CC-AEF0-228E539D8522") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E2\\u05DE\\u05D5\\u05D3-\\u05DC\\u05D9\\u05D3\\u05D9\\u05DD-\\u05DE\\u05D5\\u05D1\\u05D9\\u05D9\\u05DC",
    transform: "translate(-283.000000, -985.000000)",
    fill: "#FFFFFF",
    stroke: "#2E2D79",
    strokeWidth: 1.512
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 283.756,
    y: 985.756,
    width: 20.488,
    height: 20.488
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxEmpty);
export default __webpack_public_path__ + "static/media/checkbox-empty.f38bda95f318d4c226945b10eac6fbb8.svg";
export { ForwardRef as ReactComponent };